export enum ActionableLinkType {
  RecommendedConsultantApproval        = 1,
  ProjectCallTimeConfirmation          = 2,
  AdHocCallRejection                   = 3,
  AdHocCallTimeConfirmation            = 4,
}